import type { ReactElement } from "react";

import type { Demographics } from "../api/types";

// Human headings for the demographics keys the API summarizes
// (common/stats.py _DEMOGRAPHIC_FIELDS).
const FIELD_TITLES: Record<string, string> = {
  sex: "Sex",
  race: "Race",
  ethnicity: "Ethnicity",
  smoking: "Smoking History",
  alcohol: "Consumes Alcohol",
};

// Demographic distributions of the one-time questionnaire answers — plain
// count + share per answer (no inline bars). Shared by the admin and collab
// overviews; the FaceAge stats table is a separate component (AgeStatsTable).
// `n` is unique individuals (the FaceAge table's N counts photos).
export function StatsSummary({
  demographics,
  n,
}: {
  demographics: Demographics;
  n: number;
}): ReactElement {
  return (
    <>
      <h3>Demographics &amp; Health</h3>
      <p className="muted">N (Individuals): {n}</p>
      {Object.entries(demographics).map(([field, distribution]) => {
        const entries = Object.entries(distribution).sort((a, b) => b[1] - a[1]);
        const total = entries.reduce((sum, [, count]) => sum + count, 0);
        return (
          <div key={field}>
            <h4>{FIELD_TITLES[field] ?? field}</h4>
            {total === 0 ? (
              <p className="muted">No answers yet.</p>
            ) : (
              <table className="data-table breakdown">
                <tbody>
                  {entries.map(([answer, count]) => (
                    <tr key={answer}>
                      <th scope="row" className="muted">
                        {answer}
                      </th>
                      <td className="num">
                        {count} <span className="muted">({Math.round((count / total) * 100)}%)</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        );
      })}
    </>
  );
}
